import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  Home, Briefcase, 
  Users, BookOpen, Info, Database
} from 'lucide-react';

const MobileNavItems: React.FC = () => {
  return (
    <>
      <MobileNavItem to="/" title="Home" icon={<Home className="h-4 w-4 mr-2" />} />
      <MobileNavItem to="/diensten" title="Diensten" icon={<Briefcase className="h-4 w-4 mr-2" />} />
      <MobileNavItem to="/producten" title="AM Intelligence" icon={<Database className="h-4 w-4 mr-2" />} />
      <MobileNavItem to="/jobs" title="Jobs" icon={<Users className="h-4 w-4 mr-2" />} />
      <MobileNavItem to="/over-ons" title="Over ons" icon={<Info className="h-4 w-4 mr-2" />} />
      <MobileNavItem to="/blog" title="Blog" icon={<BookOpen className="h-4 w-4 mr-2" />} />
    </>
  );
};

interface MobileNavItemProps {
  to: string;
  title: string;
  icon: React.ReactNode;
  badge?: string;
}

const MobileNavItem: React.FC<MobileNavItemProps> = ({ to, title, icon, badge }) => {
  return (
    <NavLink to={to} className={({ isActive }) => 
      `px-4 py-3 text-sm font-medium flex items-center ${isActive ? 'text-brand-red' : 'text-gray-700 hover:text-gray-900'}`
    }>
      {icon}
      <span>{title}</span>
      {badge && (
        <span className="ml-2 text-xs px-1.5 py-0.5 rounded-full bg-brand-red/10 text-brand-red font-medium">
          {badge}
        </span>
      )}
    </NavLink>
  );
};

export default MobileNavItems;
